import currentLangReducer from "./currentLangSlice";
import customerReducer from "./customerSlice";
import fetchStateReducer from "./fetchStateSlice";
import notificationReducer from "./notificationMessageSlice";
import notificationStatusReducer from "./notificationStatusSlice";
import recordingReducer from "./recordingSlice";
import activeCameraReducer from "./setActiveCameraSlice";
import userReducer from "./userSlice";
import versionsReducer from "./versionsSlice";
import { combineReducers } from "@reduxjs/toolkit";
const rootReducer = combineReducers({
    user: userReducer,
    fetchState: fetchStateReducer,
    currentLang: currentLangReducer,
    customer: customerReducer,
    notificationStatus: notificationStatusReducer,
    notificationMessage: notificationReducer,
    activeCamera: activeCameraReducer,
    versions: versionsReducer,
    recording: recordingReducer,
});
export default rootReducer;
